export function getPrimaryImage(content) {
    const first = content.mediaItems?.[0];
    if (first && first.type === 'image') {
        return { url: first.url, attachmentId: first.attachmentId };
    }
    return {
        url: content.imageUrl ?? null,
        attachmentId: content.imageAttachmentId ?? null,
    };
}
export function hasInstagramImage(content) {
    if (content.mediaItems?.some(item => item.type === 'image'))
        return true;
    return !!content.imageUrl || !!content.imageAttachmentId;
}
export function isCarouselContent(content) {
    return (content.mediaItems?.length ?? 0) >= 2;
}
//# sourceMappingURL=instagram-post-accessors.js.map